"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSuggestion = void 0;
const react_1 = require("react");
const event_callback_hook_1 = require("../../../../utils/event-callback-hook");
const utils_1 = require("../utils");
function useSuggestion(props) {
    const { cursorPosition, aliases } = props;
    /**
     * Reference to Suggestion list container.
     */
    const listRef = react_1.useRef(null);
    /**
     * Based on caret position, stores `start` and `end` of focused term.
     */
    const focusedTermPosition = react_1.useRef({
        start: 0,
        end: 0,
    });
    /**
     * List of filtered suggestions based on type of focused term.
     */
    const [suggestions, setSuggestions] = react_1.useState([]);
    /**
     * Handler function, evaluated after filterbox FIELD is changed.
     *
     * Example: AGEDA == TEST
     * - AGEDA ... field
     * - ==    ... operation
     * - TEST  ... value
     */
    const handleFieldSuggestion = event_callback_hook_1.useEventCallback((event) => {
        // console.log(event, cursorPosition);
        if (event.type === 'rule.match' &&
            (event.rule === 'Field' || event.rule === 'Value') &&
            'result' in event &&
            event.location.start.column - 1 <= cursorPosition &&
            event.location.end.column - 1 >= cursorPosition) {
            focusedTermPosition.current.start = event.location.start.offset;
            focusedTermPosition.current.end = event.location.end.offset;
            if (event.rule === 'Field') {
                const term = event.result.trim();
                const suggestions = aliases.filter((alias) => { var _a; return (_a = alias.nonAccentLabel) === null || _a === void 0 ? void 0 : _a.includes(utils_1.removeAccent(term)); });
                setSuggestions(suggestions);
            }
        }
    });
    /**
     * Handler function, evaluated after filterbox VALUE is changed.
     */
    const handleValueSuggestion = event_callback_hook_1.useEventCallback((event) => {
        if (event.type === 'rule.match' &&
            event.rule === 'Filter' &&
            'result' in event &&
            event.location.start.column - 1 <= cursorPosition &&
            event.location.end.column - 1 >= cursorPosition &&
            event.location.start.column - 1 !== focusedTermPosition.current.start) {
            const filter = utils_1.createFilters([event.result], aliases)[0];
            const column = aliases.find((alias) => alias.key === filter.field);
            if (column === null || column === void 0 ? void 0 : column.source) {
                const source = column.source.items.map((item) => ({
                    key: item.id,
                    label: item.name,
                    nonAccentLabel: utils_1.removeAccent(item.name.trim()),
                }));
                const suggestions = source.filter((alias) => { var _a; return (_a = alias.nonAccentLabel) === null || _a === void 0 ? void 0 : _a.includes(utils_1.removeAccent(event.result.value.trim())); });
                setSuggestions(suggestions);
            }
        }
    });
    /**
     * Reset suggestion list.
     */
    const clearSuggestions = event_callback_hook_1.useEventCallback(() => {
        setSuggestions([]);
    });
    return {
        listRef,
        focusedTermPosition,
        suggestions,
        setSuggestions,
        clearSuggestions,
        handleFieldSuggestion,
        handleValueSuggestion,
    };
}
exports.useSuggestion = useSuggestion;
//# sourceMappingURL=suggestion-hook.js.map